import { computed, ComputedRef, effectScope } from 'vue';
import { useLocalStorage } from '@vueuse/core';
import { useRestaurantStore } from '@/stores/restaurant.store';

export type TPosV2Override = 'default' | 'on' | 'off';

const override = useLocalStorage<TPosV2Override>('posV2Override', 'default');

let isPosV2Active: ComputedRef<boolean> | null = null;

/**
 * POS V2 rollout flag: per-branch backend flag (`branch.posV2Enabled`) with a
 * per-device localStorage override ('on'/'off' beats the branch flag).
 */
export function usePosV2() {
  if (!isPosV2Active) {
    // Detached scope: keeps the singleton computed alive after the component
    // that first called usePosV2() unmounts (otherwise it would be torn down
    // with that component's effect scope and go permanently stale).
    const scope = effectScope(true);

    isPosV2Active = scope.run(() => {
      const restaurantStore = useRestaurantStore();

      return computed(() => {
        if (override.value === 'on') return true;
        if (override.value === 'off') return false;
        return !!restaurantStore.selectedBranch?.posV2Enabled;
      });
    })!;
  }

  function setOverride(value: TPosV2Override) {
    override.value = value;
  }

  return {
    isPosV2Active,
    override,
    setOverride,
  };
}
